<!-- see https://github.com/NightCatSama/vue-slider-component/blob/master/README.md -->
<template>
  <div :class="'multiSlider '+ wrapperClass">
    <vue-slider v-model="workingData"
                :enable-cross="enableCross"
                :tooltip="'none'"
                :processStyle="processStyle"
                :railStyle="railStyle"
                :valueLabels="valueLabels"
                :lazy="false"
                :clickable="false"
                :dragOnClick="true"
                :useKeyboard="false"
                :process="process"
                :disabled="disabled"
                :class="classDots"
                :dotSize="dotSize"
                :duration=0
                @change="$emit('change')"
                v-bind="options"
    >
      <template #process="{ start, end, style, index }">
        <div :style="style" class="vue-slider-process">
          <div :class="[
              'merge-tooltip',
              'vue-slider-dot-tooltip-inner',
              'vue-slider-dot-tooltip-inner-top',
            ]"
               :style="getStyleProcessSlider(index)">
            <p class="value mb-0" v-if="showValues">
              {{ value[index] }}%
            </p>
            <fin-lexicon-text :text="valueLabels[index]" auto-solve class="label mb-0 ml-1" v-if="showLabels"/>
          </div>
        </div>
      </template>
    </vue-slider>
  </div>
</template>

<script>
import VueSlider from 'vue-slider-component'
import 'vue-slider-component/theme/default.css'
import FinLexiconText from '@/components/common/lexicon/LexiconText/index'
import AssetClasses from "@/mocks/AssetClasses"

export default {
  name: 'finMultiSlider',
  components: {
    FinLexiconText,
    VueSlider
  },
  props: {
    value: {
      type: Array
    },
    valueLabels: {
      type: Array
    },
    enableCross: {
      type: Boolean
    },
    disabled: {
      type: Boolean,
      default: false
    },
    dotSize: {
      type: String,
      default: '30'
    },
    classDots: {
      type: String,
      default: 'dot-round'
    },
    wrapperClass: {
      type: String,
      default: ''
    },
    styleProcessSlider: {
      type: String
    },
    showValues: {
      type: Boolean,
      default: true
    },
    showLabels: {
      type: Boolean,
      default: true
    },
    processStyle: {
      type: Object
    },
    railStyle: {
      type: Object
    },
    options: {
      type: Object
    }
  },
  data() {
    return {
      width: 0,
      process: val => this.getProcess(val),
      fillColors: [
        AssetClasses.items.find(item => item.id === 'SHARE').color,
        AssetClasses.items.find(item => item.id === 'SHARE_ETF').color,
        AssetClasses.items.find(item => item.id === 'CORPORATE_BONDS_ETF').color,
        AssetClasses.items.find(item => item.id === 'GOVERNMENT_BONDS_ETF').color,
        AssetClasses.items.find(item => item.id === 'COMMODITIES_ETF').color
      ]
    }
  },
  computed: {
    workingData: {
      /* The input of the component are the percents of the assets distribution. But the components need to show
        * them one after the other distributed on a 100% scale, meaning that we need to calculate the position of the values on this scale.
        * For example: the distribution 40,10,10,25,15 will be displayed with the dots placed on the values 40, 50, 60, 85, 100. */
      get() {
        const res = []

        let sum = 0
        this.value.forEach((sliderValue, index) => {
          sum += sliderValue
          res[index] = sum
        })

        return res
      },
      set(val) {
        const res = []
        val.forEach((sliderValue, index) => {
          res[index] = index === 0 ? sliderValue : sliderValue - val[index - 1]
        })

        /**
         * Input change event.
         *
         * @event input
         * @type {object}
         */
        this.$emit('input', res)
      }
    }
  },
  methods: {
    getStyleProcessSlider(index) {
      if (this.styleProcessSlider === 'alternateLabels') {
        /* display the labels under its section on an alternate way */
        let offsetLabel = 0
        if (this.$vuetify.breakpoint.smAndUp) {
          offsetLabel = index % 3 === 0 ? '60px' : (index % 3 === 1 ? '100px' : '140px')
        } else {
          offsetLabel = index % 3 === 0 ? '55px' : (index % 3 === 1 ? '95px' : '135px')
        }

        return 'transform: translate(-50%, ' + offsetLabel + '); background-color: #FFFFFF; padding: 2px;'
      } else {
        /* display the labels slightly above the rail */
        const transX = '-50%'
        return 'transform: translate(' + transX + ', 0px); background-color: #FFFFFF; padding: 2px 4px; '
      }
    },
    getProcess(val) {
      /* defines the sections of the distribution */
      const res = []

      this.workingData.forEach((sliderValue, index) => {
        res[index] = [index === 0 ? 0 : val[index - 1], val[index]]
      })

      return res
    }
  },
  mounted() {
    this.width = this.$el.getBoundingClientRect().width
  },
}
</script>

<style lang="scss" scoped>

.multiSlider {
  .merge-tooltip {
    position: absolute;
    left: 50%;
    bottom: 100%;
    background-color: transparent;
    border-color: transparent;
    color: #02073a;
  }

  /* necessary because we otherwise cannot move the dots when they have value 0 *//*
  .vue-slider-rail {
    div:nth-child(6){
      z-index: 70;
    }
    div:nth-child(6){
      z-index: 71;
    }
    div:nth-child(6){
      z-index: 72;
    }
    div:nth-child(6){
      z-index: 71;
    }
    div:nth-child(6){
      z-index: 70;
    }
  }
  */

  .vue-slider.dot-round {
    padding: 1px 0 0 0 !important;
  }

  .vue-slider-dot:last-child {
    display: none;
  }

  .dot-capacitor {
    padding: 5px 0 !important;
  }

  .vue-slider-disabled {
    height: 2px !important;

    .label {
      color: $fin-color-cool-grey;
      font-size: 12px;
      @media only screen and (max-width: 600px) {
        font-size: 11px;
      }
    }
  }

  .label {
    font-size: 14px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.4;
    letter-spacing: normal;
    text-align: center;
    @media only screen and (max-width: 600px) {
      font-size: 12px;
    }
  }

  .value {
    font-size: 17px;
    font-stretch: normal;
    font-weight: bold;
    font-style: normal;
    line-height: 1.25;
    letter-spacing: normal;
    text-align: center;

    @media only screen and (max-width: 600px) {
      font-size: 14px;
    }
  }

}

</style>
